import { render, staticRenderFns } from "./moveGroup.vue?vue&type=template&id=066c9796&scoped=true&"
import script from "./moveGroup.vue?vue&type=script&lang=js&"
export * from "./moveGroup.vue?vue&type=script&lang=js&"
import style0 from "./moveGroup.vue?vue&type=style&index=0&id=066c9796&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "066c9796",
  null
  
)

export default component.exports